import React from 'react'
import { InstagramLogo } from '../../../../assets/index'

interface HeaderProps {
  header: string
  image_size?: string
  header_text_weight?: string
  pro?: boolean
}

const InstagramHeader = ({ header, image_size = '35px', header_text_weight = 'text-sm font-bold', pro = false }: HeaderProps) => {
  return (
    <div className='flex flex-row'>
      <div className='h-full'>
        <img className={`w-[${image_size}]`} src={InstagramLogo} />
      </div>
      <div className='ml-2 text-left'>
        <div className={`${header_text_weight}`}>{header}</div>
        <div className="text-xs mt-1"> {pro ? <span className='bg-amber-400 px-2 rounded-full'>Upgrade</span> : ""}</div>
      </div>
    </div>
  )
}

export default InstagramHeader